import { Branding } from '../../../models/Branding';
import { AppState } from '..';
import { BrandingActionTypes, GET_BRANDING, GENERATE_BRANDING_ERROR } from './types';

export interface IBrandingReducerState {
    item: InstanceType<typeof Branding> | undefined;
    error: Error | undefined;
}

export const INITIAL_STATE: IBrandingReducerState = {
    item: undefined,
    error: undefined,
};

export default function(state = INITIAL_STATE, action: BrandingActionTypes) {
    switch (action.type) {
        case GET_BRANDING:
            return { ...state, item: action.payload };
        case GENERATE_BRANDING_ERROR:
            return { ...state, error: action.error };
        default:
            return state;
    }
}

export const selectBranding = (state: AppState) => state?.branding?.item;
